import convertExcelToJson from 'convert-excel-to-json';
import { showError } from 'infra/helpers/alerta';
import {Buffer} from 'buffer';

export default async function excelToJson<T extends {index: string}, K> (file: File)  {
  const arrayBuffer = await file.arrayBuffer();

  const buffer = Buffer.from(arrayBuffer).toString("base64");

  const dataExcel = convertExcelToJson({
    source: buffer,
  });

  const foldersSheet = Object.keys(dataExcel);

  const [headers, ...cols] = dataExcel[foldersSheet[0]];

  if (!cols.length) {
    showError(
      "Planilha inválida. Certifique-se que as colunas estão iguais ao exemplo e que a planilha contém dados!"
    );
    return [];
  }
  

  const rows: T[] = [];

  let i = 0;

  for (const col of cols) {
    i++;

    const row: T = {
      index: `${i}º`,
    } as T;

    for (const header in headers) {
      const head: keyof K = headers[header];
      const value = col[header];

      (row as any)[head] =
        typeof value === "string" ? value?.trim() : value;
    }

    rows.push(row);
  }

  return rows;
};